import { HashLink } from 'react-router-hash-link';
import FirstRef from './FirstRef';
import LastRef from './LastRef';
import EvidenceLevel from './EvidenceLevel';
import OriginalDB from './OriginalDB';
import GenePMID from './GenePMID';

function AboutAttributesGeneDisease() {
  return (
    <div id="section46">
      <h3>Gene-Disease Associations</h3>
      <ul>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/docs?section=metrics&subsection=gdaScore" className="js-fix-scroll">
            DISGENET score
          </HashLink>
        </li>
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/docs?section=assoctypeont#types-ontology" className="js-fix-scroll">
            DISGENET Gene-Disease Association Type
          </HashLink>
        </li>
        <EvidenceLevel />
        <li className="bullet-item">
          The{' '}
          <HashLink smooth to="/docs?section=metrics&subsection=evindex" className="js-fix-scroll">
            Evidence Index
          </HashLink>
        </li>
        <FirstRef />
        <LastRef />
        <GenePMID />
        <li className="bullet-item">
          A representative sentence from the publication describing the association between the gene and the
          disease (if a representative sentence is not found, we provide the title of the paper)
        </li>
        <li className="bullet-item">
          Chemical: chemicals detected in the context of the gene-disease association.
        </li>
        <OriginalDB />
        <li className="bullet-item">
          Ancestry: ancestry information from the original GWAS study or identified from the publication by
          text-mining. Ancestry is standardized using the{' '}
          <a href="https://github.com/EBISPOT/hancestro" target="_blank" rel="noreferrer">
            Hancestro ontology
          </a>
          .
        </li>
        <li className="bullet-item">
          Disease model: describes the biological or experimental model in which the association evidence was
          generated, such as human subjects, animal models, cell lines, or other experimental systems.
        </li>
        <li className="bullet-item">
          Sex/Gender: describes the sex or gender associated with the evidence when this information is
          reported in the supporting publication.
        </li>
        <li className="bullet-item">
          Polarity: indicates the polarity level of the sentence; for instance if the sentence provides
          supporting evidence for the association, the polarity is positive. Otherwise, if the sentence
          provides non-supporting evidence for the association, the polarity is negative.
        </li>
        <li className="bullet-item">
          ​​Chemical Effect: classification of the effect of a chemical on the disease, provided by processing
          expert-curated resources that provide adverse effect information and indications. By using the
          Chemical Effect attribute, you can select chemicals that are used for the treatment of a disease
          (therapeutic) or lead to a disease (toxicity). In addition, for relations reported by ClinPGX,
          effects include Dosage, Efficacy, Metabolism/PK, PD.
        </li>
        <li className="bullet-item">
          My Score: a user-defined weighted score that allows users to assign weights to selected data sources
          contributing to the association. This score provides a customizable measure of confidence in a
          gene-disease association based on user preferences.
        </li>
      </ul>
    </div>
  );
}

export default AboutAttributesGeneDisease;
